import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Investor";

import disBankSlice from "./features/distributor/bank";
import disBizSlice from "./features/distributor/biz";
import bankSliceInd from "./features/indinvestor/bankSliceInd";
import profSlice from "./features/indinvestor/profSlice";
import bankSlice from "./features/institutionalInvestor/bankSlice";
import bizSlice from "./features/institutionalInvestor/bizSlice";
import repSlice from "./features/institutionalInvestor/repSlice";
import BorbankSlice from "./features/merchant/bankSlice";
import bizBorSlice from "./features/merchant/biz";
import docBorrowerSlice from "./features/merchant/doc";
import MerchantSlice from "./features/merchant/MerchantSlice/MerchantSlice";
import PaymentTrackingSlice from "./features/merchant/MerchantSlice/PaymentTrackingSlice";
import BorrepSlice from "./features/merchant/rep";
import docSlice from "./features/registration/docSlice";
import bulkSlice from "./features/sku/bulkSlice";

export const investorReducers = {
  auth: authReducer,
  biz: bizSlice,
  rep: repSlice,
  bank: bankSlice,
  doc: docSlice,
  disBiz: disBizSlice,
  borBiz: bizBorSlice,
  BorBank: BorbankSlice,
  disBank: disBankSlice,
  Borrep: BorrepSlice,
  bordoc: docBorrowerSlice,
  prof: profSlice,
  bankInd: bankSliceInd,
  bulk: bulkSlice,
  merchantReducer: MerchantSlice,
  paymentReducer: PaymentTrackingSlice,
};
